module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "divhn"
  }, [_c('h2', {
    staticClass: "h2n"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("CHAPTER 2")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('h2', {
    staticClass: "h2title"
  }, [_vm._v("A-12 Construction and Testing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "big"
  }, [_c('strong', [_vm._v("In the summer of 1960,")])]), _vm._v(" as the jigs began to go together inside the Burbank building where the aircraft were to be built, the difficulties entailed in the A-12’s construction began to surface in ever-increasing numbers. The early decision to build the aircraft out of titanium to cope with the high temperatures at the Mach 3+ cruise speeds was a first for the aviation industry. Though numerous aircraft parts had been manufactured from titanium, an entire airframe had never been attempted. The A-12 was composed of 85 percent titanium and 15 percent composite materials. Though strong, relatively light, and capable of retaining its exceptional strength characteristics at very high temperatures, it also suffered from scarcity, high cost, and a reputation for being extremely difficult to work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other manufacturing challenges included the development of a fuel that could be safely stored in tanks where the temperature of the fuel reached 350 degrees F.; gaseous nitrogen inerting of the fuel tanks; a special lubricating oil that could be used effectively on parts that reached temperatures of 600 degrees F.; hydraulic seals capable of maintain their integrity at high temperatures; and a quartz glass window that could retain its optical qualities while being exposed to the extreme temperatures of the A-12’s operating environment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another major problem was the radar-cross section (RCS). The areas causing the most RCS difficulty included the vertical stabilizers and the forward section of the engine nacelles. Lockheed conducted considerable research into the use of ferrites, high-temperature radar-absorbing materials and high-temperature plastic structures to find methods for reducing the RCS. Eventually, the vertical stabilizers, originally made of titanium, were replaced by high-temperature composites. This was almost certainly the first time such materials had been used for a major part of an aircraft’s structure. Since the main domestic supplier, Titanium Metals Corporation of America, couldn’t supply the entire project, titanium was sourced from all around the world—ironically, including the Soviet Union. Using third parties and bogus companies, the CIA managed to purchase the necessary base metal from the Russians—who unwittingly helped the create the very plane that would be spying on them. It was the beginning of stealth technology.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-01.jpg",
      "width": "500px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Groom Lake, also known as Area 51, was originally built to fly the CIA’s U-2, but in later years took on a variety of top secret missions and aircraft testing. "), _c('em', [_vm._v("Nevada Aerospace Hall of Fame Collection")])])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0024-01.jpg",
      "width": "500px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("On 26 February 1962, the first A-12 made the trip from Burbank, California, to Groom Lake in specially built containers. The width of the trailers restricted the convoy’s speed and required the cooperation of the highway patrol from California and Nevada. "), _c('em', [_vm._v("Lockheed Martin")])])])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The old U-2 location, Area 51, was prepared to accept the first A-12 aircraft. The considerable work needed to bring the facility up to standards was initiated in September 1960. In the interim, the runway was lengthened to 8,500 feet from the original 5,000 feet; the highway leading to the location was resurfaced; three surplus Navy hangars were erected at the north side; and an additional hundred surplus Navy buildings were moved to the base. Meanwhile, the prototype aircraft were being assembled with considerable difficulty at Burbank, California.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Excerpts from Kelly Johnson’s log underscore some of the problems. March 6, 1961—“Having trouble with wing load distribution and have to put twist in outboard leading edge.” During March, Johnson informed his CIA liaison that “schedules are in jeopardy on two fronts. One is the assembly of the wing and the other is in satisfactory development of the engine. Our evaluation shows that each of ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("these programs is from three to four months behind the current schedule.”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The CIA’s Deputy Director for Plans Richard Bissell replied, “I have learned of your expected additional delay in first flight from 30 August to 1 December 1961. This news is extremely shocking on top of our previous slippage from May to August and my understanding as of our meeting 19 December that the titanium extrusion problems essentially overcome. I trust this is the last of such disappointments short of a severe earthquake in Burbank.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfortunately Johnson’s problems continued. Construction pressures were intense at Burbank and work went on around the clock in three shifts. Engine problems continued as well. Following a meeting with Pratt & Whitney in Florida, Johnson notes in his log, “Their troubles are desperate. It is almost unbelievable that they could have gotten this far with the engine without uncovering basic problems which have been normal in every jet engine. Prospects of an early flight engine are dismal and I feel our program is greatly jeopardized. It’s a good thing we went to the J-75, although these engines too have troubles and require new compressor discs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During January of 1962 an agreement was reached with the Federal Aviation Administration (FAA) permitting the expansion of the restricted airspace surrounding the test location. Select FAA controllers were cleared for Oxcart operations. Additionally, nearby military radar facilities were briefed not to report radar sightings of high- performance aircraft.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first A-12 was ready for final assembly during mid-February 1962. It was decided that, in light of the secrecy surrounding the project, the aircraft could not be flown out of Burbank. A special trailer was built to haul the aircraft across country. A thorough survey of the route during June 1961 assessed the hazards of moving the actual aircraft and showed that a package measuring 35 feet wide and 103 feet long could be moved along the road without major difficulty. Several road signs would have to be removed and selected trees would have to be trimmed. The entire fuselage, minus the wings, was crafted, covered with canvas, and loaded on the special trailer. The convoy left Burbank at 2:30 a.m. and arrived at the test location at 1:00 p.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After its arrival at Area 51, reassembly of the first aircraft and installation of the J-75 engines began. On 25 April 1962, the aircraft appeared ready for its initial test flight. Skunk Works test pilot Lou Schalk, who joined the program two years earlier, had spent many hours in the cockpit and a rudimentary simulator. By the advent of the first A-12 taxi and previous flight testing, Lou was as prepared as possible. He recounts his first flight:")]), _vm._v(" "), _c('p', {
    staticClass: "block1"
  }, [_vm._v("It had a very light load of fuel so it sort of accelerated really fast. Not many people really knew that we were going to lift the airplane off . . . some of the people in flight test engineering did know this. I was probably 3–4 percent behind the aft limit center of gravity (cg) when I lifted off the airplane . . . so it was unstable . . . and I fought it longitudinally which translated into lateral and directional problems, too.")])]), _c('p', {
    staticClass: "block"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("The airplane wallowed through the sky until I finally felt I had it under control enough to put it back down on the ground . . . which I did. By that time I was over the lakebed. This developed a big cloud of dust and the tower wanted to know if everything was OK. I said yes . . . but I have to roll out here on the lakebed and turn around and come back. They couldn’t hear me because the Ultra High Frequency (UHF) transmitting antenna was on the bottom of the fuselage and that blanked out my transmission . . . so no one heard what I was saying. They asked me again and I said there was no problem. I wasn’t trying to stomp on the brakes or anything. Everyone was having a heart attack. I finally made the turn and came out of the ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("cloud of dust and they saw I hadn’t run into the mountains on the other side of the lake and blow up the airplane. There was a huge sigh of relief!")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "block"
  }, [_vm._v("I still didn’t know what the devil was wrong with the airplane . . .why it handled so poorly . . . it didn’t do that in the simulator and Kelly and I were talking about what we should do if we fly the airplane the next day. I said I think we should turn the dampers on . . . they were off when I was taxiing. On the second flight we were going to fly the plane around with the gear down.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-01.jpg",
      "width": "500px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("On 26 April 1962, Lockheed chief test pilot, Lou Schalk, takes to the skies with the first flight in A-12, tail number 924, at Groom Lake. The trouble-free flight lasted thirty-five minutes. Seven days later, on the third test flight, Lou broke Mach 1. "), _c('em', [_vm._v("Lockheed Martin")])])])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent1"
  }, [_vm._v("On 26 April 1962 Lou Schalk flew the A-12 on its first scheduled airborne test flight. Kelly Johnson wrote, “We decided to fly with the stability augmentation system engaged on April 26. Everyone was awake just about through the night. We rolled out early and at 7:05 a.m. took off, making a beautiful takeoff. In flight we investigated the effects of the stability augmentation. We showed that the first flight troubles were not caused by basic aircraft stability.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout 1962 more A-12 aircraft were trucked to Area 51. In November a two-seat trainer model of the A-12 arrived. It had an elevated second seat in the position behind the cockpit, normally occupied by sensor gear. Troubles still plagued the J-58 engine development. The trainer was equipped with J-75 engines so that flight training could be accommodated as expeditiously as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In October 1962 the Cuban missile crisis reinvigorated the A-12 program. The loss of Maj. Rudolph Anderson’s U-2 over Cuba on 27 October underscored the increasing vulnerability of this subsonic platform when operating in denied airspace. Successful execution of Oxcart now became a matter of the highest national priority. At the end of 1962, two A-12s were in flight test, one powered by J-57s, and the other with one J-57 and one J-58 engine. A speed of Mach 2.16 and an altitude of 60,000 feet had been achieved. By the end of January 1963, ten J-58s had been delivered to the test location. The first A-12 flight with two J-58 engines took place on 13 January 1963. After that flight all the other A-12s were retrofitted with J-58s as well as the A-12s coming off the production line.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0027-01.jpg",
      "width": "500px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Lou Schalk being congratulated after the perfect first flight test of the A-12. Right to left: Larry Bohanon, manager of A-12 flight testing at Groom Lake; CIA Deputy Director for Plans Rich Bissell; Schalk; Najeeb Halaby, administrator of the Federal Aviation Administration (FAA), and Joseph Charyk, director of the National Reconnaissance Office (NRO). "), _c('em', [_vm._v("Lockheed Martin")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 24 May 1963, the third A-12, involved in a subsonic engine test flight and piloted by Ken Collins, crashed fourteen miles south of Wendover, Utah. Ken successfully ejected and was unhurt. The A-12 fleet was temporarily grounded while an investigation was conducted. A pitot-static system failure due to icing was determined to be the culprit. In mid-October Kelly Johnson wrote, “We have been to Mach 3.0 twice, the first time being on 20 July 1963. On the second flight we blew an engine at design speed. It was very difficult to slow down and it rattled Lou Schalk around for three minutes. The aircraft stability augmentation system (SAS) did precisely as I asked it to do three years ago and no high structural loads were obtained.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon, another Lockheed test pilot, Jim Eastham, took the first A-12 out to a speed of Mach 3.3 and then cruised at Mach 3.2 for fifteen minutes. By the end of 1964 the A-12 fleet, consisting of eleven aircraft, had logged over 1,214 flights and 1,669 hours of flying time. Only six hours and twenty-three minutes had been logged above Mach 3.0 and only thirty-three minutes at Mach 3.2.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0028-01.jpg",
      "width": "500px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Habus attend the thirty-ninth anniversary of the first flight of the A-12 at the Virginia Aviation Museum on 28 April 2001. Lou Schalk (holding his coat) was on hand to talk about the first flight. "), _c('em', [_vm._v("Rich Graham")])])])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("One flight was sent out to demonstrate complete systems reliability at Mach 3.05 and at 2,300 nautical miles (NM) range at an altitude of 76,000 feet. On 27 January 1965, an A-12 embarked on the first long-range, high-speed flight. Airborne for an hour and forty minutes, it spent an hour and fifteen minutes at Mach 3.1 or above. The mission covered 2,580 NM while cruising between 75,600 and 80,000 feet. During the tests that ensued, the A-12 achieved a maximum speed of Mach 3.29, an altitude of 90,000 feet, and a sustained flight time above Mach 3.2 of one hour and fourteen minutes. The longest flight lasted six hours and twenty minutes. During 1965, the “critical situation” the CIA’s A-12 detachment had been waiting for finally emerged in Asia. On 18 March, the CIA’s director, John A. McCone, discussed with Secretary of Defense Robert McNamara and Deputy Secretary Cyrus Vance the increasing hazards to U-2 and unmanned drone reconnaissance of Communist China. It was further agreed that the necessary steps to begin the operation of flying Oxcart over China should proceed, with the construction and necessary arrangements on Okinawa, Japan. No decision was taken to fly the A-12s over China; this decision could only be made by the president.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The operation to fly A-12s out of Kadena Air Base, Okinawa, Japan, was codenamed Black Shield. The deployment of surface-to-air missiles around Hanoi also had caught U.S. forces off guard in the rapidly escalating Vietnam War. Secretary of Defense McNamara called this to the attention of the under secretary of the Air Force and inquired about the practicability of substituting A-12s for U-2s. He was told that Black Shield could operate over Vietnam as soon as adequate aircraft performance was achieved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 20 November 1965, Kelly Johnson wrote to the CIA, “. . . over all, my considered opinion is that the aircraft can be successfully deployed for the Black Shield mission with what I would consider to be at least as low a degree of risk as in the early U-2 deployment days. It is probably much less risky than our first U-2 deployment. I think the time has come when the bird should leave its nest.” However, despite all its achievements, the A-12 was not called into operational duty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout 1966 the A-12 program in effect had nothing to do. Repeated requests to authorize the flights over China and North Vietnam were refused. The CIA, the Joint Chiefs of Staff, and the president’s Foreign Intelligence Advisory Board favored the overflights while Alexis Johnson of the State Department, McNamara, and Vance opposed them. Perhaps most importantly, the president sided with the opposition, agreeing that the technological and political risks were too great.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("On 12 May 1966 Kelly Johnson wrote, “As of this date, there is still no go-ahead for the deployment, although it seems fairly optimistic. The airplanes are ready to go.” On 10 October 1966 he noted, “Still no ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("deployment. We are making forty flights a month. The airplane is working quite well.” An impressive demonstration of the A-12’s capability occurred on 21 December 1966 when test pilot Bill Park flew the aircraft 10,198 statute miles (SM) in six hours. It was a record, unapproachable by any other aircraft in the world.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The CIA’s inability to justify using the A-12 operationally by the end of 1966 had led to concerns the aircraft would soon be placed in storage, which accelerated during the first few months of 1967. On 21 March 1967, Kelly Johnson wrote, “The Air Force and the Program Office are having quite a time about storing the A-12s. It appears that half of them will be stored by the middle of this year and all of them by February of 1968. In the meantime, five airplanes will be kept on alert status for deployment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With this bleak prognosis, it came as somewhat of a surprise during early May when prospects for operational deployment suddenly took a new turn. Concerns that SAMs would be deployed in North Vietnam suddenly provided the small A-12 community with a glimmer of hope. The president asked for a review of the surface-to-air activity and what might be done to monitor it. The CIA suggested using the A-12s. It was noted that the A-12 camera was far superior to those then being used on the various drones and the U-2s over North Vietnam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a result, State and Defense Department members reexamined the requirements and political risks of using the A-12s and the CIA’s new director, Richard Helms, submitted another formal proposal to deploy the A-12s. President Johnson granted permission for use of the A-12 aircraft, and, on 16 May 1967, his assistant, Walt Rostow, formally conveyed the president’s decision. Black Shield was put into effect immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 17 May 1967, the first support components of Black Shield were airlifted to Kadena Air Base (AB) in Okinawa. They were followed on 22 May by the first A-12, which arrived six hours after departing the United States. A second A-12 followed on 24 May, and a third on 26 May. On 29 May, the unit was declared ready to fly its first operational mission. Under the command of Col. Hugh Slater, 260 personnel had been transferred to Kadena as part of the Black Shield team.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 31 May the first A-12 operational sortie was flown. The flight followed a route over North Vietnam and the Demilitarized Zone (DMZ). It lasted three hours and thirty-nine minutes. Results were satisfactory and 70 of the 190 surface-to-air missile sites in North Vietnam were photographed, along with nine other priority targets. No radar signals were detected, implying that the Chinese and North Vietnamese had not known about the A-12 presence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over the next year, twenty-nine A-12 sorties were flown, twenty-six over North Vietnam, three over North Korea by Dennis Sullivan, Ken Collins, Francis “Frank” Murray, Mel Vojvodich, Jack Layton, and Jack Weeks. On 23 January 1968, the USS "), _c('em', [_vm._v("Pueblo")]), _vm._v(", a Navy ship designed to intercept and sample the electronic environment off the east coast of North Korea, was seized in the middle of the night. Immediately, a CIA plan was implemented to fly the A-12s over North Korea. On 26 January, CIA pilot Jack Weeks’ reconnaissance package found the "), _c('em', [_vm._v("Pueblo")]), _vm._v(". This incident clearly demonstrated the ability of the A-12 to respond with minimal lead times to international incidents of political and military importance.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-01.jpg",
      "width": "500px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The four A-12 hangars built by the CIA on Kadena AB, Okinawa, Japan. The elongated center structure housed all of the various maintenance shops. The same facilities were used for SR-71 operations. "), _c('em', [_vm._v("Lockheed Martin")])])])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0030-01.jpg",
      "width": "500px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("All ten remaining A-12 aircraft parked at the Lockheed plant in Palmdale, California, after the Oxcart program was terminated. Second from the left is the dual-seated A-12, nicknamed the “titanium goose,” used to train A-12 pilots. It was never configured with J-58 engines. "), _c('em', [_vm._v("Lockheed Martin")])])])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0030-02.jpg",
      "width": "500px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Kelly Johnson in the front seat of the “titanium goose,” his only A-12 flight. Kelly has a standard Air Force helmet and flight suit on. Unfortunately, he never experienced a Mach 3+ flight because the plane was not capable of those speeds with two J-57 engines. "), _c('em', [_vm._v("Lockheed Martin")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("The last A-12 mission was on 8 May 1968, and the Kadena Detachment was then advised to prepare to deploy back to the United States. In May, Kelly Johnson wrote, “The decision was taken to phase out the A-12 by about mid-June. Plans were put into effect for storing the A-12 aircraft at Palmdale, CA.” During March of 1968, SR-71s began arriving at Kadena to take over the Black Shield commitment. On 16 May, the Secretary of Defense, Clark Clifford, reaffirmed a previous decision to terminate and store the A-12 aircraft. On 21 May, President Johnson confirmed the decision. In gradual stages the A-12 was placed on standby to back up the SR-71. A date of 8 June was selected as the earliest possible date to begin redeployment of the A-12s back to the United States. By now the A-12 flights from Okinawa were limited to those essential for maintaining pilot proficiency.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("During the final days overseas, the A-12 program suffered a final blow that was as inexplicable as it was tragic. On 4 June 1968, an A-12 piloted by Jack Weeks set out from Kadena on a check flight necessitated by an engine change. Weeks was last heard from when his plane was 520 miles east of Manila. Search and rescue operations found nothing. No cause for the accident was ever ascertained and his disappearance remains a mystery to this day.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "height": "450px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0031-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Memorial Wall at the entrance to CIA headquarters. Each of the 103 engraved stars on the marble wall represents a CIA officer killed in the line of duty. The Book of Honor lists seventy-nine names; the remaining twenty-four must remain secret, even in death, and are represented by a star in the book. Jack Weeks and Walt Ray are listed in the books. "), _c('em', [_vm._v("CIA")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726606ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 75
// module chunks = 0